import { render, staticRenderFns } from "./CopyGraderuleGroupSlidebar.vue?vue&type=template&id=83c6f776"
import script from "./CopyGraderuleGroupSlidebar.vue?vue&type=script&lang=js"
export * from "./CopyGraderuleGroupSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports